/**
 * @generated SignedSource<<f0b3d3fade932aa0f5c6a4fec94bd768>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PERIODICITY = "DAILY" | "WEEKLY" | "MONTHLY" | "%future added value";
export type PERIOD_BUDGET_TYPE = "FIXED_PRICE" | "FIXED_HOURS" | "TIME_AND_MATERIALS" | "%future added value";
export type UpdateRetainerPeriodBulkInput = {
  ids?: ReadonlyArray<string | null> | null;
  periodHoursAmount?: number | null;
  periodPriceAmount?: number | null;
  periodLocked?: boolean | null;
  periodLockedTime?: string | null;
  rolloverIdsToRevert?: ReadonlyArray<string | null> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateRetainerPeriodBulkMutation$variables = {
  input: UpdateRetainerPeriodBulkInput;
};
export type updateRetainerPeriodBulkMutation$data = {
  readonly updateRetainerPeriodBulk: {
    readonly errors: ReadonlyArray<string | null> | null;
    readonly project: {
      readonly retainerPeriods: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly name: string | null;
            readonly startYear: number | null;
            readonly startMonth: number | null;
            readonly startDay: number | null;
            readonly endYear: number | null;
            readonly endMonth: number | null;
            readonly endDay: number | null;
            readonly available: number | null;
            readonly periodLength: number | null;
            readonly periodPeriodicity: PERIODICITY | null;
            readonly periodPriceAmount: number | null;
            readonly periodHoursAmount: number | null;
            readonly periodBudgetType: PERIOD_BUDGET_TYPE | null;
            readonly periodSettingIgnoreForBilling: boolean | null;
            readonly periodSettingSubtractValue: boolean | null;
            readonly periodSettingRollValue: boolean | null;
            readonly periodSettingAddExpenses: boolean | null;
            readonly periodDifferencePriceAmount: number | null;
            readonly periodDifferenceHoursAmount: number | null;
            readonly sharedPeriodDifferenceHoursAmount: number | null;
            readonly sharedPeriodDifferencePriceAmount: number | null;
            readonly ignoredRolloverHours: number | null;
            readonly ignoredRolloverPrice: number | null;
            readonly periodLocked: boolean | null;
            readonly periodLockedTime: string | null;
            readonly periodDifferenceSplit: boolean | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};
export type updateRetainerPeriodBulkMutation = {
  variables: updateRetainerPeriodBulkMutation$variables;
  response: updateRetainerPeriodBulkMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 100000
    }
  ],
  "concreteType": "RetainerPeriodTypeConnection",
  "kind": "LinkedField",
  "name": "retainerPeriods",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RetainerPeriodTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RetainerPeriodType",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startYear",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startMonth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startDay",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endYear",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endMonth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endDay",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "available",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodLength",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodPeriodicity",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodPriceAmount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodHoursAmount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodBudgetType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodSettingIgnoreForBilling",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodSettingSubtractValue",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodSettingRollValue",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodSettingAddExpenses",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodDifferencePriceAmount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodDifferenceHoursAmount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sharedPeriodDifferenceHoursAmount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sharedPeriodDifferencePriceAmount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ignoredRolloverHours",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ignoredRolloverPrice",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodLocked",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodLockedTime",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodDifferenceSplit",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "retainerPeriods(first:100000)"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateRetainerPeriodBulkMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateRetainerPeriodBulkPayload",
        "kind": "LinkedField",
        "name": "updateRetainerPeriodBulk",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateRetainerPeriodBulkMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateRetainerPeriodBulkPayload",
        "kind": "LinkedField",
        "name": "updateRetainerPeriodBulk",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8d28fd6aa331b11d939375866bc0299f",
    "id": null,
    "metadata": {},
    "name": "updateRetainerPeriodBulkMutation",
    "operationKind": "mutation",
    "text": "mutation updateRetainerPeriodBulkMutation(\n  $input: UpdateRetainerPeriodBulkInput!\n) {\n  updateRetainerPeriodBulk(input: $input) {\n    errors\n    project {\n      retainerPeriods(first: 100000) {\n        edges {\n          node {\n            id\n            name\n            startYear\n            startMonth\n            startDay\n            endYear\n            endMonth\n            endDay\n            available\n            periodLength\n            periodPeriodicity\n            periodPriceAmount\n            periodHoursAmount\n            periodBudgetType\n            periodSettingIgnoreForBilling\n            periodSettingSubtractValue\n            periodSettingRollValue\n            periodSettingAddExpenses\n            periodDifferencePriceAmount\n            periodDifferenceHoursAmount\n            sharedPeriodDifferenceHoursAmount\n            sharedPeriodDifferencePriceAmount\n            ignoredRolloverHours\n            ignoredRolloverPrice\n            periodLocked\n            periodLockedTime\n            periodDifferenceSplit\n          }\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8b8da6d0b52268e2ebdb14a8a2a28712";

export default node;
